import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { updatePlanGroup, createPlanGroup } from "../../slices/plangroups";
import { useNavigate } from 'react-router-dom';

const PlanGroupForm = ({ planGroup }) => {

    let timer = null;

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const onSubmit = (data) => {
        if (planGroup) {
            Promise.resolve(dispatch(updatePlanGroup({ id: planGroup.id, args: data })))
            .then(data => {
                navigate('/settings/plangroups/')
            })
        } else {
            Promise.resolve(dispatch(createPlanGroup(data)))
            .then(data => {
                navigate('/settings/plangroups/')
            })
        }
    }

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: { errors }
    } = useForm({
        defaultValues: {
            name: planGroup?.name
        }
    });


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col mb-4">
                            <label>{gettext('Name')}</label>
                            <input type="text" {...register("name")} className="form-control" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="clamped text-end">
                <input className="btn btn-primary mt-4 ms-auto" type="submit" value={gettext("Save")} />
            </div>
        </form>
    )
}

export default PlanGroupForm